import { Tabs, type Tab } from "shared/components/BaseTabs";
import {
  ShowingNotesType,
  useNotesController
} from "shared/queries/useNotesController";

export const NotesTabs = ({
  notesController,
  tabClassName
}: {
  notesController: ReturnType<typeof useNotesController>;
  tabClassName?: string;
}) => {
  const mentionCount = notesController.mentionNotesCount;

  const tabs: Tab<ShowingNotesType>[] = [
    {
      value: ShowingNotesType.ALL,
      label: "All"
    },
    {
      value: ShowingNotesType.MENTIONS,
      label: "Mentions",
      ...(mentionCount > 0 && {
        rightElement: { type: "counter" as const, count: mentionCount }
      })
    },
    {
      value: ShowingNotesType.ATTACHMENTS,
      label: "Files"
    }
  ];

  return (
    <Tabs
      className={tabClassName}
      tabStyle="line"
      size="sm"
      fullWidthTabs={false}
      onChange={(tab) => notesController.changeShowingNotesType(tab)}
      active={notesController.showingNotesType}
      tabs={tabs}
    />
  );
};
